(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/common-sport.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/common-sport.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.game_results.models.CommonSport = Backbone.Model.extend({
  defaults: {
    showLiveResults: false,
    getLiveResults: false,
    userHasRefreshed: false
  },
  initialize(options) {
    this.set('productName', options.product);
    let path = '';
    switch (options.product) {
      case 'topptipset':
        path = '/draw/1/topptipsetfamily/draws/result';
        this.set('getLiveResults', true);
        break;
      case 'powerplay':
        path = "/draw/1/".concat(this.get('productName'), "/draws/result");
        this.set('getLiveResults', true);
        break;
      case 'europatipset':
      case 'stryktipset':
        path = "/draw/1/".concat(this.get('productName'), "/draws/result");
        this.set('getLiveResults', true);
        break;
      default:
        path = "/draw/1/".concat(this.get('productName'), "/draws/result");
    }
    this.path = path;
  },
  getGameResult() {
    const productName = this.get('productName');
    const openRounds = svs.game_results.data ? svs.game_results.data[productName] : '';
    let paths;
    if (this.get('getLiveResults') && openRounds && openRounds.resultDates && openRounds.resultDates.length > 0) {
      const roundToFetch = openRounds.resultDates[openRounds.resultDates.length - 1];
      paths = [];
      paths.push("/draw/1/".concat(roundToFetch.product, "/draws/").concat(roundToFetch.drawNumber));
      paths.push("/draw/1/".concat(roundToFetch.product, "/draws/forecast/").concat(roundToFetch.drawNumber));
      if (productName !== 'topptipset') {
        paths.push("/draw/1/".concat(roundToFetch.product, "/draws/result"));
      } else {
        paths.push('/draw/1/topptipsetfamily/draws/result');
      }
    }
    this.startLoader();
    svs.core.jupiter.get(paths ? paths : this.path, response => {
      let result;
      let nextRoundDraw;
      let forecast;
      if (response) {
        if (response.responses) {
          if (this.get('getLiveResults')) {
            const nextRounds = _.filter(response.responses, currentObject => currentObject && currentObject.draw && currentObject.draw.drawStateId == 4);
            nextRoundDraw = nextRounds.length > 0 ? nextRounds[0].draw : '';
            const nextForecasts = _.filter(response.responses, currentObject => currentObject && currentObject.forecastResult && currentObject.forecastResult.drawState == 4);
            forecast = nextForecasts.length > 0 && nextForecasts[0].forecastResult ? nextForecasts[0].forecastResult : '';
          } else {
            nextRoundDraw = response.responses[0] && response.responses[0].draw ? response.responses[0].draw : '';
            forecast = response.responses[1] && response.responses[1].forecastResult ? response.responses[1].forecastResult : '';
          }

          if (!nextRoundDraw || !forecast || nextRoundDraw && nextRoundDraw.drawStateId < svs.game_results.constants.drawStates.CLOSED) {
            var _ref, _result$0$regCloseTim, _result$, _nextRoundDraw;
            if (response.responses[2].results) {
              result = Array.isArray(response.responses[2].results) ? response.responses[2].results : [response.responses[2].results];
            } else {
              result = response.responses[2] && response.responses[2].result ? [response.responses[2].result] : [response.result];
            }
            this.set({
              result
            }, {
              silent: true
            });
            this.set('regCloseTime', (_ref = (_result$0$regCloseTim = (_result$ = result[0]) === null || _result$ === void 0 ? void 0 : _result$.regCloseTime) !== null && _result$0$regCloseTim !== void 0 ? _result$0$regCloseTim : (_nextRoundDraw = nextRoundDraw) === null || _nextRoundDraw === void 0 ? void 0 : _nextRoundDraw.regCloseTime) !== null && _ref !== void 0 ? _ref : '');
            this.stopLoader();
          } else {
            this.set('isLive', true);
            this.set('liveResults', nextRoundDraw, {
              silent: true
            });
            if (forecast) {
              this.set('showLiveResults', true);
              this.set('forecast', forecast);
              const drawState = forecast.drawState;
              const roundIsLive = drawState >= svs.game_results.constants.drawStates.CLOSED && drawState < svs.game_results.constants.drawStates.FINALIZED;
              this.set('roundIsLive', roundIsLive);
              this.set('drawState', drawState, {
                silent: true
              });
            }
            this.set('regCloseTime', nextRoundDraw.regCloseTime);
            this.stopLoader();
            const liveResultsSocketPath = "/draw/1/".concat(this.get('productName'), "/draws/").concat(nextRoundDraw.drawNumber);
            const forecastSocketPath = "/draw/1/".concat(this.get('productName'), "/draws/forecast/").concat(nextRoundDraw.drawNumber);
            this.set('liveResultsSocketPath', liveResultsSocketPath, {
              silent: true
            });
            this.set('forecastSocketPath', forecastSocketPath, {
              silent: true
            });
            this.subscribeLive();
          }
        } else {
          if (response.results) {
            result = Object.prototype.toString.call(response.results) === '[object Array]' ? response.results : [response.results];
          } else {
            if (response.result && Array.isArray(response.result.distribution)) {
              response.result.distribution.forEach(row => {
                row.name = row.name.replace(/\s/g, '\xA0');
              });
            }
            result = [response.result];
          }
          result = result.map(res => _objectSpread(_objectSpread({}, res), {}, {
            events: res.events.map(event => _objectSpread(_objectSpread({}, event), {}, {
              hasMatch: true
            }))
          }));
          this.set({
            result
          }, {
            silent: true
          });
          this.set('regCloseTime', result[0].regCloseTime);
          this.stopLoader();
        }
      }
    }, error => {
      this.showLoadingError(this.path, error);
    });
  },
  getResult(draws, date) {
    let pathsData;
    let paths = [];
    this.set('currentDate', date);
    this.startLoader();
    this.unsubscribeLive();
    if (draws && draws[0] && draws[0].product && draws[0].drawNumber) {
      pathsData = draws;
    } else {
      this.set('userHasRefreshed', true);
      let drawNumbers = draws.drawNumber ? draws.drawNumber : draws[0].drawNumber;
      if (!_.isArray(drawNumbers)) {
        drawNumbers = [drawNumbers];
      }
      const product = this.get('product');
      pathsData = drawNumbers.map(drawNumber => {
        if (product === 'topptipset') {
          return [{
            product: 'topptipset',
            drawNumber
          }, {
            product: 'topptipsetextra',
            drawNumber
          }, {
            product: 'topptipsetstryk',
            drawNumber
          }];
        }
        return {
          product,
          drawNumber
        };
      });
      pathsData = _.flatten(pathsData);
    }
    paths = pathsData.map(x => this.setupPath(x.product, x.drawNumber));
    paths = _.flatten(paths);
    svs.core.jupiter.get(paths, response => {
      const product = this.get('product');
      const productName = this.get('productName');
      const currentDate = this.get('currentDate');
      const userHasRefreshed = this.get('userHasRefreshed');
      let currentDrawNumber;
      let nextRound;
      let forecast;
      let isSameDate;
      this.clear({
        silent: true
      });
      this.set('productName', productName.toLowerCase(), {
        silent: true
      });
      this.set('product', product, {
        silent: true
      });
      if (response.responses) {
        const results = response.responses.map(res => {
          isSameDate = res.result && dateFns.isSameDay(new Date(currentDate), new Date(res.result.regCloseTime));
          if (!_.isUndefined(res.result) && (Boolean(isSameDate) || _.isUndefined(currentDate))) {
            return _objectSpread(_objectSpread({}, res.result), {}, {
              events: res.result ? res.result.events.map(result => {
                const drawEvents = response.responses[0].draw.drawEvents || response.responses[0].draw.events;
                return _objectSpread(_objectSpread({}, result), {}, {
                  hasMatch: Boolean(drawEvents.filter(draw => draw.eventNumber === result.eventNumber)[0].match)
                });
              }) : []
            });
          }
          return undefined;
        }).filter(res => res !== undefined);
        if (product === 'topptipset' && userHasRefreshed || results.length === 0) {
          if (_.isUndefined(currentDate)) {
            nextRound = response.responses[0] && response.responses[0].draw;
            forecast = response.responses[1] && response.responses[1].forecastResult;
          } else {
            const nextOpenRound = _.find(response.responses, res => {
              isSameDate = res.draw && dateFns.isSameDay(new Date(currentDate), new Date(res.draw.regCloseTime));
              if (isSameDate) {
                currentDrawNumber = res.draw.drawNumber;
                return true;
              }
            });
            nextRound = nextOpenRound && nextOpenRound.draw;
            const nextForecast = _.find(response.responses, res => {
              isSameDate = res.forecastResult && dateFns.isSameDay(new Date(currentDate), new Date(res.forecastResult.time));
              if (isSameDate) {
                return res.forecastResult && res.forecastResult.drawnum === currentDrawNumber;
              }
            });
            forecast = nextForecast && nextForecast.forecastResult;
          }
        }
        if (results.length > 0) {
          this.set({
            result: results
          }, {
            silent: true
          });
          this.set('regCloseTime', results[results.length - 1].regCloseTime);
          this.stopLoader();
        }
        if (nextRound) {
          if (nextRound.drawStateId < svs.game_results.constants.drawStates.CLOSED) {
            this.set('isBeforeStart', true);
          }
          this.set('liveResults', nextRound, {
            silent: true
          });
          this.set('showLiveResults', true);
          if (forecast) {
            const drawState = forecast.drawState;
            const roundIsLive = drawState >= svs.game_results.constants.drawStates.CLOSED && drawState < svs.game_results.constants.drawStates.FINALIZED;
            this.set('roundIsLive', roundIsLive);
            this.set('forecast', forecast);
            this.set('drawState', drawState, {
              silent: true
            });
          }
          this.set('regCloseTime', this.get('regCloseTime') || nextRound.regCloseTime);
          this.stopLoader();
          const currentProduct = nextRound.productName.toLowerCase().replace(/ /g, '');
          const liveResultsSocketPath = "/draw/1/".concat(currentProduct, "/draws/").concat(nextRound.drawNumber);
          const forecastSocketPath = "/draw/1/".concat(currentProduct, "/draws/forecast/").concat(nextRound.drawNumber);
          this.set('liveResultsSocketPath', liveResultsSocketPath, {
            silent: true
          });
          this.set('forecastSocketPath', forecastSocketPath, {
            silent: true
          });
          this.subscribeLive();
        }
      } else if (response.result) {
        const result = [response.result];
        this.set({
          result
        }, {
          silent: true
        });
        this.set('regCloseTime', result[0].regCloseTime);
        this.stopLoader();
      }
    }, error => {
      this.showLoadingError(paths, error);
    });
  },
  getSportkryssResult(date) {
    const path = "/draw/1/results/datepicker/?product=sportkrysset&year=".concat(dateFns.getYear(new Date(date)), "&month=").concat(dateFns.getMonth(new Date(date)) + 1);
    this.startLoader();
    svs.core.jupiter.get(path, response => {
      this.set('sportkryssDraws', response.resultDates, {
        silent: true
      });
      const draw = _.find(this.get('sportkryssDraws'), obj => obj.date.split('T')[0] === date.split('T')[0]);
      if (draw) {
        const path = "/draw/1/".concat(draw.product, "/draws/").concat(draw.drawNumber, "/result");
        svs.core.jupiter.get(path, response => {
          if (response.error) {
            this.unset('sportkryssResult');
            this.stopLoader();
          } else {
            this.unset('sportkryssResult', {
              silent: true
            });
            this.set('sportkryssResult', response.result);
            this.stopLoader();
          }
        }, error => {
          this.renderErrorMessage(path, error);
        });
      }
      this.stopLoader();
    }, error => {
      this.renderErrorMessage(path, error);
    });
  },
  renderErrorMessage() {
    svs.sport.sport_common.showErrorDialog('Nu gick något fel', 'Kan inte hämta resultatet för Sportkryss.<br>Försök igen om en stund eller kontakta kundservice: 0770 - 11 11 11');
    this.stopLoader();
  },
  forecastSocketUpdate(value) {
    if (value.forecastResult) {
      const forecastResult = value.forecastResult;
      if (this.get('isBeforeStart') && forecastResult.drawState >= svs.game_results.constants.drawStates.CLOSED) {
        this.set('isBeforeStart', false);
      }
      this.set('forecast', forecastResult);
      this.set('changes', forecastResult.changes, {
        silent: true
      });
      this.set('resultIdx', forecastResult.resultIdx);
      this.set('drawState', forecastResult.drawState);
    }
  },
  liveResultsSocketUpdate(value) {
    if (value.draw) {
      this.set('liveResults', value.draw);
    }
  },
  setupPath(product, drawNumber) {
    return ["/draw/1/".concat(product, "/draws/").concat(drawNumber), "/draw/1/".concat(product, "/draws/forecast/").concat(drawNumber), "/draw/1/".concat(product, "/draws/").concat(drawNumber, "/result")];
  },
  startLoader() {
    this.loader = setTimeout(() => {
      $('#coupon').css('visibility', 'hidden');
      svs.components.loader.show();
    }, 250);
  },
  stopLoader() {
    clearTimeout(this.loader);
    svs.components.loader.hide();
    $('#coupon').css('visibility', 'visible');
  },
  unsubscribeLive() {
    if (this.get('liveResultsSocketPath')) {
      svs.core.socket.unsubscribe(this.get('liveResultsSocketPath'), this.liveResultsSocketUpdate);
    }
    if (this.get('forecastSocketPath')) {
      svs.core.socket.unsubscribe(this.get('forecastSocketPath'), this.forecastSocketUpdate);
    }
  },
  subscribeLive() {
    svs.core.socket.subscribe(this.get('liveResultsSocketPath'), this.liveResultsSocketUpdate, this, false);
    svs.core.socket.subscribe(this.get('forecastSocketPath'), this.forecastSocketUpdate, this, false);
  },
  showLoadingError() {
    svs.sport.sport_common.showErrorDialog('Nu gick något fel', "Kan inte h\xE4mta senaste resultatet f\xF6r ".concat(this.get('productName'), "<br>F\xF6rs\xF6k igen om en stund eller kontakta kundservice: 0770 - 11 11 11"));
    this.stopLoader();
  }
});

 })(window);